import React from 'react';

const TestPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Tailwind CSS Test Page</h1>
        
        {/* Test basic styling */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Basic Styling Test</h2>
          <p className="text-gray-600 mb-4">
            This page tests if Tailwind CSS is working correctly. You should see:
          </p>
          <ul className="list-disc list-inside text-gray-600 space-y-2">
            <li>Proper colors (gray backgrounds, blue text)</li>
            <li>Rounded corners on the card</li>
            <li>Shadow effects</li>
            <li>Proper spacing and typography</li>
          </ul>
        </div>

        {/* Test grid layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          <div className="bg-blue-500 text-white p-4 rounded-lg">
            <h3 className="font-semibold mb-2">Blue Card</h3>
            <p className="text-sm">This should be blue with white text</p>
          </div>
          <div className="bg-green-500 text-white p-4 rounded-lg">
            <h3 className="font-semibold mb-2">Green Card</h3>
            <p className="text-sm">This should be green with white text</p>
          </div>
          <div className="bg-red-500 text-white p-4 rounded-lg">
            <h3 className="font-semibold mb-2">Red Card</h3>
            <p className="text-sm">This should be red with white text</p>
          </div>
        </div>

        {/* Test buttons */}
        <div className="space-x-4 mb-8">
          <button className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors">
            Primary Button
          </button>
          <button className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300 transition-colors">
            Secondary Button
          </button>
          <button className="border border-blue-600 text-blue-600 px-4 py-2 rounded-lg hover:bg-blue-50 transition-colors">
            Outline Button
          </button>
        </div>

        {/* Test icons */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">Icon Test</h2>
          <div className="flex items-center space-x-4">
            <div className="flex items-center text-gray-600">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>Clock Icon</span>
            </div>
            <div className="flex items-center text-gray-600">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <span>Email Icon</span>
            </div>
            <div className="flex items-center text-gray-600">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <span>Phone Icon</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestPage;
